import { CircularProgress, Link } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { ApiConfig, apiCall } from '../../config/api'

interface ButtonDownloadTemplateProps {
  nameFileTemplate: string
  textButtonParam: string
}

export const ButtonDownloadTemplate: React.FC<ButtonDownloadTemplateProps> = ({
  nameFileTemplate,
  textButtonParam = 'Descargar Plantilla'
}) => {
  const [disabledLink, setDisabledLink] = useState<boolean>(false)

  const handleDownloadTemplate = () => {
    setDisabledLink(true)
    setTimeout(() => {
      apiCall(
        'GET',
        `${ApiConfig.ProcessApi}/GetTemplateFile/${nameFileTemplate}`,
        {
          responseType: 'blob'
        }
      )
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLink(false)
    }, 1500)
  }

  return disabledLink ? (
    <Fragment>
      <Link
        style={{
          cursor: 'pointer',
          pointerEvents: 'none'
        }}
        onClick={handleDownloadTemplate}
      >
        Descargando Plantilla...
      </Link>{' '}
      <CircularProgress size='0.9rem' />
    </Fragment>
  ) : (
    <Link style={{ cursor: 'pointer' }} onClick={handleDownloadTemplate}>
      {textButtonParam}
    </Link>
  )
}
